import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import TimePicker from '../TimePicker';
import Button from '../../Button';
import Popup from '../Popup';
import ValidationError from '../ValidationError';
import styles from './index.styl';

export default function TimePickerButton({
  title,
  time,
  disabled,
  cancelButtonTitle,
  saveButtonTitle,
  onSave,
  validateTime,
  format,
}) {
  const [isPopupVisible, toggleVisibility] = useState(false);
  const [pickerTime, setTime] = useState(time);
  const [error, showError] = useState(null);

  const togglePopup = useCallback(() => {
    toggleVisibility(!isPopupVisible);
    showError(null);
  }, [isPopupVisible, toggleVisibility]);

  const handleSave = () => {
    const errorMessage = validateTime(pickerTime);

    if (!errorMessage) {
      onSave(pickerTime);
      toggleVisibility(false);
    } else {
      showError(errorMessage);
    }
  };

  return (
    <div className="dib">
      <Button
        className="mr3"
        color="accent"
        border
        disabled={disabled}
        onClick={togglePopup}
        type="button"
      >
        {title}
      </Button>
      <Popup
        opened={isPopupVisible}
        white
        width="rubber"
        enabled
        withHeading={false}
        contentNoPadding
      >
        <TimePicker
          time={pickerTime}
          onChange={val => setTime(val)}
          format={format}
        />
        <If condition={error}>
          <ValidationError content={error} className={styles.error} />
        </If>
        <div className="pt3 pb1 flex justify-end">
          <Button color="transparent" onClick={togglePopup}>
            {cancelButtonTitle}
          </Button>
          <Button color="transparent" onClick={handleSave}>
            {saveButtonTitle}
          </Button>
        </div>
      </Popup>
    </div>
  );
}

TimePickerButton.propTypes = {
  title: PropTypes.string,
  time: PropTypes.string,
  disabled: PropTypes.bool,
  cancelButtonTitle: PropTypes.string,
  saveButtonTitle: PropTypes.string,
  onSave: PropTypes.func,
  validateTime: PropTypes.func,
  format: PropTypes.string,
};

TimePickerButton.defaultProps = {
  time: '12:00 PM',
};



// WEBPACK FOOTER //
// ./src/components/common/TimePickerButton/index.jsx